import { Booking, BookingData, BookingRepository, DatabaseService } from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getBookingRepository(
  databaseService: DatabaseService,
): BookingRepository {
  return getGenericRepository<Booking, BookingData>(
    () => DatabaseCollection.BOOKINGS,
    databaseService,
  );
}
